import cx from 'classnames'

import './style.scss'

export type TokenDisplayProps = {
  children?: any
  className?: string
  type: 'empl'
  tokenStyle?: 'gray' | 'none'
  displaySize?: 'compact'
}

const TokenDisplay = ({
  children,
  type,
  tokenStyle = 'gray',
  displaySize,
  className,
}: TokenDisplayProps) => {
  return (
    <div
      className={cx('TokenDisplay', {
        [`TokenDisplay--icon-${type}`]: type,
        [`TokenDisplay--${tokenStyle}`]: tokenStyle,
        [`TokenDisplay--${displaySize}`]: displaySize,
        [className]: className,
      })}
    >
      {children}
    </div>
  )
}

export default TokenDisplay
